/**
 * Phase 38 — one container's hits today, on the Live card: "↻ hit again ×2
 * today · 2,500 SMS" with each hit in the hover, and what was held and why
 * (outside the window, a stopped group, a burned list, the chain's end).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Repeat } from 'lucide-react';
import type { DropGenHitReport } from '@trafficpulse/shared';

const n = (v: number) => v.toLocaleString('en-US');
const hhmm = (minute: number) => `${String(Math.floor(minute / 60) % 24).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`;

export const HitsLine: FC<{ hits?: DropGenHitReport | null }> = ({ hits }) => {
  if (!hits || (hits.hits.length === 0 && hits.held.length === 0)) return null;
  const sms = hits.hits.reduce((s, h) => s + h.amount, 0);
  const title = hits.hits.map((h) => `${hhmm(h.minute)} · ${h.listName ?? 'list'} · #${h.hitNo} · ${h.note}`).join('\n');
  return (
    <div className="flex flex-col gap-0.5 text-xs" data-testid="hits-line">
      {hits.hits.length > 0 ? (
        <span className="flex items-center gap-1.5 text-success" title={title}>
          <Repeat className="h-3.5 w-3.5" aria-hidden />
          hit again ×{hits.hits.length} today · {n(sms)} SMS
        </span>
      ) : null}
      {hits.held.map((h) => (
        <span key={h.sourceDropId} className="text-warning">
          would hit again — held: {h.why}
          {h.listName ? ` (${h.listName})` : ''}
        </span>
      ))}
    </div>
  );
};
